import { types } from '@spa/services/alert'
import { _, CZ, getLang } from '@spa/utils/gettext'
import { EquipmentStatus } from '@spa/types/services'

const options: { [key: string]: { [index: number]: string } } = {
  reservationStatuses: {
    1: _('Požadováno'),
    4: _('Rezervováno')
  },
  timeRequirements: {
    1: _('Měření rezervace'),
    2: _('Servis'),
    3: _('Údržba'),
    4: _('Školení'),
    5: _('Výuka'),
    6: _('Rezervace FS'),
    7: _('Blokace')
  },
  timeRequirementsNano: {
    1: _('Měření rezervace'),
    2: _('Servis'),
    3: _('Údržba'),
    4: _('Školení'),
    5: _('Výuka'),
    7: _('Blokace')
  },
  shortTimeRequirements: {
    1: _('Měření rezervace'),
    5: _('Výuka')
  },
  timeRequirementsBadges: {
    1: 'M',
    2: 'S',
    3: getLang() === CZ ? 'Ú' : 'M',
    4: getLang() === CZ ? 'Š' : 'T',
    5: getLang() === CZ ? 'V' : 'E',
    6: 'R',
    7: 'B'
  },
  recordingStatuses: {
    [types.info]: _('Info'),
    [types.warning]: _('Minor issue'),
    [types.danger]: _('Serious issue'),
  },
  yesNo: {
    0: _('Ne'),
    1: _('Ano'),
  },
  equipmentStatuses: {
    [EquipmentStatus.Operational]: _('Operational'),
    [EquipmentStatus.Issues]: _('Minor issues'),
    [EquipmentStatus.NonOperational]: _('Non-operational')
  },
  equipmentRequestStateCodes: {
    1: _('Požadováno'),
    304: _('Rezervováno'),
  }
}

export default options
